(function () {
  const SELECTOR = '[data-rr]';
  const initialized = new WeakSet();

  function init(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    const track = root.querySelector('[data-rr-track]');
    const prevBtn = root.querySelector('[data-rr-prev]');
    const nextBtn = root.querySelector('[data-rr-next]');
    if (!track) return;

    const cards = () => Array.from(track.querySelectorAll('[data-rr-card]'));

    const getActiveIndex = () => {
      const items = cards();
      if (items.length === 0) return 0;
      const trackRect = track.getBoundingClientRect();
      const viewportCenter = trackRect.left + trackRect.width / 2;
      let closest = 0;
      let closestDist = Infinity;
      items.forEach((el, i) => {
        const rect = el.getBoundingClientRect();
        const center = rect.left + rect.width / 2;
        const dist = Math.abs(center - viewportCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    };

    const scrollToIndex = (i, behavior = 'smooth') => {
      const items = cards();
      if (items.length === 0) return;
      const clamped = Math.max(0, Math.min(items.length - 1, i));
      const card = items[clamped];
      const cardLeft = card.offsetLeft;
      const cardWidth = card.offsetWidth;
      const viewportWidth = track.clientWidth;
      const maxScroll = track.scrollWidth - viewportWidth;
      let targetLeft = cardLeft - (viewportWidth - cardWidth) / 2;
      targetLeft = Math.max(0, Math.min(maxScroll, targetLeft));
      track.scrollTo({ left: targetLeft, behavior });
      updateArrows(clamped);
    };

    const updateArrows = (activeIndex) => {
      const items = cards();
      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= maxScroll - 2;
      if (prevBtn) prevBtn.disabled = atStart;
      if (nextBtn) nextBtn.disabled = atEnd || items.length < 2;
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        scrollToIndex(getActiveIndex() - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        scrollToIndex(getActiveIndex() + 1);
      });
    }

    track.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        scrollToIndex(getActiveIndex() - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        scrollToIndex(getActiveIndex() + 1);
      }
    });

    let scrollTimer = null;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => updateArrows(getActiveIndex()), 80);
      },
      { passive: true }
    );

    requestAnimationFrame(() => updateArrows(getActiveIndex()));

    let resizeTimer = null;
    window.addEventListener('resize', () => {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        updateArrows(getActiveIndex());
      }, 150);
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:select', (e) => {
    const el = e.target && e.target.querySelector ? e.target.querySelector(SELECTOR) : null;
    if (el) init(el);
  });
})();
